import type { ReactNode, PropsWithChildren, FC } from 'react';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

interface Props extends PlainButtonOrLinkProps {
  icon: ReactNode;
  a11yText: string;
}

export const IconButton: FC<PropsWithChildren<Props>> = ({
  icon,
  a11yText,
  children,
  ...buttonProps
}) => {
  return (
    <PlainButtonOrLink {...buttonProps}>
      {icon}
      <VisuallyHidden>{a11yText}</VisuallyHidden>
      {children}
    </PlainButtonOrLink>
  );
};

export default IconButton;
